const  DOCUMENT = 'PARTNER_INVOCIES_';

export const GET_PARTNER_INVOICE = DOCUMENT + 'GET_PARTNER_INVOICE';
export const GET_PARTNER_INVOICE_SUCCESS = DOCUMENT + 'GET_PARTNER_INVOICE_SUCCESS';
export const GET_PARTNER_INVOICE_ERROR = DOCUMENT + 'GET_PARTNER_INVOICE_ERROR';

export const CREATE_PARTNER_INVOICE = DOCUMENT + 'CREATE_PARTNER_INVOICE';
export const CREATE_PARTNER_INVOICE_SUCCESS = DOCUMENT + 'CREATE_PARTNER_INVOICE_SUCCESS';
export const CREATE_PARTNER_INVOICE_ERROR = DOCUMENT + 'CREATE_PARTNER_INVOICE_ERROR';